

export class MenuType {
    public static readonly INTRO = new MenuType("Intro");
    public static readonly GAME = new MenuType("Game");
    public static readonly PREFERENCES = new MenuType("Preferences");
    public static readonly RULES = new MenuType("Rules");
    public static readonly PATH = new MenuType("Path");
    public static readonly WIN = new MenuType("Win");
    public static readonly STATS = new MenuType("Stats");
    public static readonly ABORT = new MenuType("Abort");
    public static readonly ERROR = new MenuType("Error");
    public static readonly LOADING = new MenuType("Loading");

    private readonly name: string;

    constructor(name: string) {
        this.name = name;
    }

    getName(): string {
        return this.name;
    }
}
